import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Snackbar,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
} from "@mui/material";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../../styles.module.css";
import {
  ActionMsg,
  Breadcrumb,
  Cancel,
  CTSinput,
  CTSinputNo,
  HandleCloseSnackbar,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import {
  addRate,
  editDeleteRate,
  getProductList,
  getCustomerList,
  getUOMList,
} from "../../../actions/actions";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const RateAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.customer_product_details_id : null;
  
  const [data, setData] = useState({
    cust_name: editData ? editData.cust_name : "",
    date: editData ? editData.date : "",
    //customer_product_details_description: editData ? editData.customer_product_details_description : "",
    cp_details: editData ? editData.cp_details : "",
   
  });

  const handleChange = ({ target }) => {
    const value = target.value;
    if (target.name === "prod_code") {
      const selectedProduct = product.find((p) => p.prod_code === value);
      setData({
        ...data,
        [target.name]: value,
        prod_description: selectedProduct
          ? selectedProduct.prod_description
          : "", // Add this
      });
    } else {
      setData({
        ...data,
        [target.name]: value,
      });
    }
    data[target.name] = target.value;
  };
  
  const onSubmit = (event) => {
    const rateData = {
        ...data,
        customer_product_details_id: editid,
        cp_details: JSON.stringify(cp_details), // Ensure cp_details is populated correctly
        changedUpdatedValue: "edit",
    };
    if (editData) {
        dispatch(editDeleteRate(rateData));
    } else {
        dispatch(addRate(rateData));
    }
}

  /////////////////////

  const { product } = useSelector((state) => state.product);

  // const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    dispatch(getProductList({ page: 0, size: 10, searchKey: "" }));
  }, [dispatch]);

  ////////

  const { customer } = useSelector((state) => state.customer);

  // const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    dispatch(getCustomerList({ page: 0, size: 10, searchKey: "" }));
  }, [dispatch]);

  ////////////

  const { uom } = useSelector((state) => state.uom);

  // const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    dispatch(getUOMList({ page: 0, size: 10, searchKey: "" }));
  }, [dispatch]);

  ////////////////////////////////////


  let navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector((state) => state.rate.message);
  const { shouldShowMsg, responseMessage } = useMessageHandler(
    null,
    navigate,
    setSuccessMessage,
    respMsgState
  );

  useEffect(() => { }, [shouldShowMsg, responseMessage]);

  const [cp_details, setCp_details] = useState(
        editData
          ? JSON.parse(editData.cp_details)
          : [
              {
                sr_no: "",
                product: "",
                product_description: "",
                rate: "",
                uom: "",
                transport_charges: "",
                max_holding: "",
                rent_free_days: "",
                rental_per_day: "",

              },
            ]
      );

      const handleChangeInput = (e, i) => {
        const array = cp_details;
        let result = array[i];
        result[e.target.name] = e.target.value; // Ensure this is updating correctly
        array[i] = result;
        setCp_details(array);
        console.log(cp_details); // Log the updated cp_details
        if (e.target.name === "product") {
            const selectedProduct = product.find(
                (product) => product.prod_code === e.target.value
            );
            console.log("Selected Product:", selectedProduct); // Log the selected product
            if (selectedProduct) {
                result["product_description"] = selectedProduct.prod_description; // Ensure this is set correctly
            } else {
                result["product_description"] = ""; // Ensure this is handled
            }
        }
    }
      const handleAddSPQuotationFields = () => {
            setCp_details([
              ...cp_details,
              {
                sr_no: "",
                product: "",
                product_description: "",
                rate: "",
                uom: "",
                transport_charges: "",
                max_holding: "",
                rent_free_days: "",
                rental_per_day: "",
                
              },
            ]);
          };

          const handleRemoveDO = (id) => {
                const values = [...cp_details];
                values.splice(
                  values.findIndex((value) => value.sr_no === id),
                  1
                );
                setCp_details(values);
                // setIsUpdateArray(isUpdateArray ? false : true);
                // const reducer = (previousValue, currentValue) =>
                //   previousValue + currentValue;
            
                // const totalCount =
                //   values &&
                //   values
                //     .map((value) =>
                //       value.total && value.total ? parseFloat(value.total) : 0
                //     )
                  //  .reduce(reducer);
                // const gstTotalCount =
                //   values &&
                //   values
                //     .map((value) =>
                //       value.tax_amount && value.tax_amount
                //         ? parseFloat(value.tax_amount)
                //         : 0
                //     )
                   // .reduce(reducer);
                // const amountTotalCount =
                //   values &&
                //   values
                //     .map((value) =>
                //       value.amount && value.amount ? parseFloat(value.amount) : 0
                //     )
                   // .reduce(reducer);
            
                // setTotal(totalCount);
                // setTotalTax(gstTotalCount);
                // // setGrossTotal(amountTotalCount + gstTotalCount);
                // setGrossTotal(amountTotalCount);
              };
  console.log(cp_details);
  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        <Breadcrumb routeSegments={[{ name: "DO" }]} />
        <Box style={{ height: "20px" }}> </Box>
        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1} sx={{ mt: 0 }}>
              <Grid item xs={4}>
                <Grid container spacing={1} sx={{ mt: 0 }}></Grid>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={2} className={`${styles.grid_lable}`}>
                     <Typography className={`${styles.cts_lable_sm}`}>
                        Customer Name :
                      </Typography>
                    </Grid>
                    <Grid item xs={4} className={`${styles.grid_input}`}>
            
                      <TextField
                        select
                        size="small"
                        fullWidth
                        onChange={handleChange}
                        name="cust_name"
                        value={data.cust_name}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          style: {
                            height: 30,
                            fontSize: 12,
                            backgroundColor: "white",
                          },
                        }}
                        SelectProps={{
                          MenuProps: { PaperProps: { style: { maxHeight: 200 } } },
                        }}
                      >
                        {customer &&
                          customer.map((customer) => (
                            <MenuItem className={`${styles.cts_lable}`}
                              key={customer.cust_id}
                              value={customer.cust_name}
                            >
                              {customer.cust_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
         
                  <Grid item xs={1} className={`${styles.grid_lable}`}>
                    <Typography className={`${styles.cts_lable}`}>
                       Date
                    </Typography>
                  </Grid>
                  <Grid item xs={4} className={`${styles.grid_input}`}>
                    <CTSinput
                      size="small"
                      fullWidth
                      type="date"
                      onChange={handleChange}
                      name="date" 
                      value={data.date}
                    />
                  </Grid>
                </Grid> 
              </Grid>
              <Grid item xs={12}>
                <TableContainer
                  style={{
                    maxHeight: "250px",
                    minHeight: "248px",
                    marginTop: "5px",
                  }}
                >
                  <Table
                    sx={{ minWidth: 750 }}
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          // width="8%"
                        >
                          Sr No
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          // width="25%"
                        >
                          Product
                        </StyledTableCell>
                        <StyledTableCell
                          align="left"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                          width="25%"
                        >
                          Product Description
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Rate
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          UOM
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Transport Charges
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Max Holding
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Rent free days
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Rental per day(after rent free period)
                        </StyledTableCell>
                        
                       
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        >
                          Action
                        </StyledTableCell>
                        <StyledTableCell
                          align="right"
                          className={`${styles.table_head}`}
                          sx={{ backgroundColor: "#ededed", fontSize: "12px" }}
                        ></StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className={`${styles.table_head}`}
                        ></StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {cp_details &&
                        cp_details.map((row, index) => (
                          <StyledTableRow key={row.sr_no}>
                            <StyledTableCell>
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="sr_no"
                                value={row.sr_no}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            
                            <StyledTableCell>
                           
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                type="text"
                                name="product"
                                value={row.product}
                                onChange={(e) => handleChangeInput(e, index)}
                                select // Add a select dropdown for product codes
                              >
                               
                                {product.map((product) => (
                                  <MenuItem className={`${styles.cts_lable}`}
                                    key={product.prod_id}
                                    value={product.prod_code}
                                  >
                                    {product.prod_code}
                                  </MenuItem>
                                ))}
                              </CTSinput>
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                           
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="product_description"
                                value={row.product_description} // This should be auto-filled based on the selected product
                                onChange={(e) => handleChangeInput(e, index)} // If you want to allow manual editing
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="rate"
                                value={row.rate}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinput
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="uom"
                                value={row.uom}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinputNo
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="transport_charges"
                                value={row.transport_charges}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinputNo
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="max_holding"
                                value={row.max_holding}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinputNo
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="rent_free_days"
                                value={row.rent_free_days}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="centr">
                              <CTSinputNo
                                fullWidth
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                type="text"
                                name="rental_per_day"
                                value={row.rental_per_day}
                                onChange={(e) => handleChangeInput(e, index)}
                              />
                            </StyledTableCell>
                            
                            <StyledTableCell align="right">
                              <Box
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={handleAddSPQuotationFields}
                                >
                                  <AddIcon
                                    sx={{
                                      fontSize: "16px",
                                      color: "#1b52d1",
                                      border: "1px solid #1b52d1",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </IconButton>
                                {index === 0 ? (
                                  <IconButton
                                    disabled
                                    size="small"
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{
                                        color: "#c0c0c0",
                                        fontSize: "18px",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRemoveDO(row.sr_no)}
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    <DeleteForeverIcon
                                      sx={{ fontSize: "18px" }}
                                    />
                                  </IconButton>
                                )}
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box sx={{ marginTop: "12px", float: "right" }}>
                  <Button
                    color="primary"
                    id={`${styles.btn_save}`}
                    variant="contained"
                    type="submit"
                  >
                    <SaveIcon
                      style={{ fontSize: "16px", marginRight: "10px" }}
                    />{" "}
                    {editData ? "Update" : "Save"}
                  </Button>
                  <Cancel />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Paper>
    </>
  );

  };
export default RateAdd;



